export default __webpack_public_path__ + "static/media/tesa-sub.3853c455.jpg";